import { PromotedProductDTO } from "@hazadapt-git/public-core-base";

type HardcodedProduct = Omit<PromotedProductDTO, "date_created" | "date_modified">

export const getHardcodedProducts = (): PromotedProductDTO[] => {
	const now = new Date()
	return HARDCODED_PRODUCTS.map(product => ({
		...product,
		date_created: now,
		date_modified: now
	}))
}

export const HARDCODED_PRODUCTS: HardcodedProduct[] = [
{
		"id": 1,
		"name": "CPRWrap™ Aid - Simplify CPR - tool for adult, child, and infant sudden cardiac arrest (SCA)",
		"image": {
				"alt": "An image of three sizes of the CPRWrap, adult, child, and infant, with each having a mouth guard and chest sheet with instructions clearly labeled.",
				"src": "",
				"url": "https://hazadapt-cms.s3.us-west-2.amazonaws.com/CPR_Wrap_bundle_bdfd57a99a.png"
		},
		"link": "https://cprwrap.com/products/bundle-pack",
		"affiliate_link": false,
		"hazards": [42,40,2],
		"stages": ["Prepare"],
		"local": false,
		"num_bookmarks": 1,
		"bookmarked": false,
		"retailer": {
				"id": 1,
				"name": "CPRWrap"
		},
},
{
		"id": 329,
		"name": "Emergency Medication Kits | use code \"hazadapt\" for $10 off order",
		"image": {
				"alt": "teal Jase Medical logo",
				"src": "",
				"url": "https://hazadapt-cms.s3.us-west-2.amazonaws.com/Jase_Logo_Teal_OFFICIAL_e1721158582233_f108ba9dad.png"
		},
		"link": "https://rstr.co/jasemedical/23204",
		"affiliate_link": false,
		"hazards": [ 103, 26, 58, 46, 71, 40, 113, 22, 111, 212, 11, 44, 62, 86, 106, 179, 3, 59, 
								 94, 5, 105, 90, 107, 68,42, 60, 4, 110, 89, 95, 278, 38, 2, 19, 21, 83, 112],
		"stages": [ "Prepare" ],
		"local": false,
		"num_bookmarks": 1,
		"bookmarked": false,
		"retailer": {
				"id": 394,
				"name": "Jase Medical"
		},
},
{
		"id": 15,
		"name": "Honda EU2200IC 2200-Watt Quiet Portable Generator",
		"image": {
				"alt": "A red and black portable generator",
				"src": "",
				"url": "https://hazadapt-cms.s3.us-west-2.amazonaws.com/71j8w_LS_2_R4_L_AC_SL_1170_1_ea8b5fbd90.jpg"
		},
		"link": "https://amzn.to/4axkcRD",
		"affiliate_link": true,
		"hazards": [ 40, 103, 71, 11, 62 ],
		"stages": [ "Prepare" ],
		"local": false,
		"num_bookmarks": 0,
		"bookmarked": false,
		"retailer": {
				"id": 28,
				"name": "Honda"
		},
}
]
